import React from "react";

export default function Dummy() {
  return <div>Table will go here</div>;
}
